import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "../components/Reveal";

const STEPS = [
  { n: "01", t: "Audit & Onboarding", d: "Discovery call, full account or catalog audit, GST / brand-registry check and a 30-60-90 day roadmap.", tags: ["Account audit", "Category approval", "Brand Registry"] },
  { n: "02", t: "Listing & Launch", d: "SEO titles, bullets, A+ content and compliant images — bulk-uploaded and approved the first time.", tags: ["Keyword research", "A+ content", "Bulk cataloging"] },
  { n: "03", t: "Ads & Growth", d: "Structured Sponsored campaigns, weekly harvest loops and price intelligence to grow sales while ACoS falls.", tags: ["Campaign architecture", "Negative keywords", "Deals & coupons"] },
  { n: "04", t: "Protect & Scale", d: "Account health monitoring, POA-ready compliance, then expansion to Flipkart, Meesho, Myntra and JioMart.", tags: ["Health monitoring", "Reinstatement", "Multi-channel"] },
];

export default function Process() {
  return (
    <section id="process" className="py-28 bg-[#0A0A0A] text-white relative overflow-hidden" data-testid="process-section">
      <div className="absolute inset-0 grain opacity-[0.05] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-20">
          <div className="lg:col-span-7">
            <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#C8956A]">02 / The Calium Method</span>
            <h2 className="mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-[-0.03em] leading-[0.95]">
              Four chapters. <span className="text-[#C8956A]">One growth story.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 font-body text-base text-white/60 leading-relaxed">
            The same operating system we've run for 5000+ sellers since 2017 — documented, measured and reported weekly.
          </p>
        </Reveal>

        <div className="relative">
          <div className="hidden lg:block absolute left-0 right-0 top-[52px] h-px bg-white/10" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                data-testid={`process-step-${i + 1}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                className="group relative"
              >
                <div className="flex items-center gap-4 mb-8">
                  <span className="font-heading text-6xl font-black text-white/10 group-hover:text-[#C8956A] transition-colors duration-500 leading-none">{s.n}</span>
                  <span className="hidden lg:block w-3 h-3 rounded-full bg-[#6B1414] ring-4 ring-[#0A0A0A] relative z-10 group-hover:scale-150 transition-transform" />
                </div>
                <h3 className="font-heading text-xl font-bold mb-3">{s.t}</h3>
                <p className="font-body text-sm text-white/60 leading-relaxed mb-6">{s.d}</p>
                <ul className="space-y-2">
                  {s.tags.map((t) => (
                    <li key={t} className="font-mono text-[10px] uppercase tracking-wider text-[#F5D5B0]/70 flex items-center gap-2">
                      <span className="w-1 h-1 bg-[#C8956A]" /> {t}
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
